import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import { Button, Col, Collapse, Form, Row } from "react-bootstrap";
import { DebounceInput } from "react-debounce-input";
import {
  EdgeType,
  VariableLocationEdges,
} from "../../../../docuclipper/DocuclipperTypes";
import PopoverHelp from "../../../Docuclipper/PopoverHelp";
import { ForbiddenWords } from "./ForbiddenWords";
import VariableLocationWords from "./VariableLocationWords";

type Props = {
  vl: VariableLocationEdges;
  onSetWords: () => any;
  onSetPercentage: () => any;
  onWordsChanged: (words: string[]) => any;
  onOffsetChanged: (offset: number) => any;
  enablePercentage: () => any;
  disablePercentage: () => any;
  onIncludeWordsCheckedChange: (checked: boolean) => any;

  edgeType: EdgeType;
};
export const VariableFieldEdge: React.SFC<Props> = ({
  vl,

  onSetWords,
  onWordsChanged,
  enablePercentage,
  disablePercentage,
  onIncludeWordsCheckedChange,
  edgeType,
  onOffsetChanged,
}) => {
  const edge = vl[edgeType];
  // }
  const [advancedExpanded, setAdvancedExpanded] = React.useState(false);
  return (
    <>
      {
        /*edge.edgeDetectionType === "words" &&*/ edge.words && (
          <>
            {/* <Form.Label>Words</Form.Label> */}
            <Row>
              <Col>
                <div className="vlocationWords">
                  <Row className="align-items-center justify-content-around">
                    <div style={{ width: "80%" }}>
                      <VariableLocationWords
                        onMenuOpen={onSetWords}
                        onWordsChanged={onWordsChanged}
                        edge={edge}
                      />
                    </div>
                    <PopoverHelp
                      header=""
                      id={`${edgeType}Help`}
                      placement="bottom"
                    >
                      {`To detect the ${edgeType} edge of the field click on `}
                      <strong>Select words</strong>
                      {`. Then click and drag to draw a box around the words that mark the ${edge} edge of the field.`}
                    </PopoverHelp>
                  </Row>
                </div>
              </Col>
            </Row>
            {/* <Row className="justify-content-end">
              <Button className="mt-2 mr-2" onClick={onSetWords}>
                Select words
              </Button>
            </Row> */}
            <div className="pl-4 mt-2">
              <Row>
                <Form.Check
                  name="useMargins"
                  type="checkbox"
                  checked={edge.percentage !== null}
                  onChange={(e) => {
                    if (e.target.checked) {
                      enablePercentage();
                    } else {
                      disablePercentage();
                    }
                  }}
                  label="Use margins when words aren't found"
                ></Form.Check>

                <PopoverHelp header="" id="vlPercentageHelp" placement="bottom">
                  <p>Drag the dashed lines to change the margins.</p>
                </PopoverHelp>
              </Row>
              {edge.percentage !== null && (
                <div className="">
                  <Form.Label>{`Margin (as page ${
                    ["top", "bottom"].includes(edgeType) ? "height" : "width"
                  } %)`}</Form.Label>
                  <Form.Control
                    readOnly={true}
                    value={edge.percentage.percentage.toFixed(2)}
                  />
                </div>
              )}
            </div>
            <Row className="align-items-center">
              <Col md="6">
                <Form.Label>Offset %:</Form.Label>
              </Col>
              <Col md="6">
                <DebounceInput
                  element={Form.Control as any}
                  debounceTimeout={300}
                  type="number"
                  value={(edge.words.offset || 0).toString()}
                  onChange={(e) => onOffsetChanged(parseFloat(e.target.value))}
                />
              </Col>
            </Row>
            <Row>
              <Button
                onClick={() => setAdvancedExpanded(!advancedExpanded)}
                variant="link"
              >
                <span className="mr-2">Advanced</span>
                <FontAwesomeIcon
                  icon={advancedExpanded ? "chevron-up" : "chevron-down"}
                />
              </Button>
            </Row>
            <Collapse in={advancedExpanded}>
              <div id="collapse-advanced">
                <div className="pl-4">
                  <Row>
                    <Form.Check
                      type="checkbox"
                      checked={edge.words.includeWordsChecked}
                      onChange={(e) =>
                        onIncludeWordsCheckedChange(e.target.checked)
                      }
                      label="Words are part of the field"
                    />

                    <PopoverHelp
                      header=""
                      id="includeWordsCheckedHelp"
                      placement="bottom"
                    >
                      <p>
                        Controls whether to include the words used to find the
                        field in the extracted data.
                      </p>
                    </PopoverHelp>
                  </Row>
                </div>
                <div className="pl-4">
                  <ForbiddenWords vl={vl} />
                </div>
              </div>
            </Collapse>

            {/* <MultiButton
              btnClassName=""
              selected={
                edge.words.wordType === "x"
                  ? (edge.words.xPosition as XPosition)
                  : (edge.words.yPosition as YPosition)
              }
              onSelect={(option) => {
                const value = option.apiName;
                if (edge.words?.wordType === "x") {
                  onXPositionChange(value as XPosition);
                } else {
                  onYPositionChange(value as YPosition);
                }
              }}
              options={
                edge.words.wordType === "x"
                  ? [
                      { text: "Left", apiName: "left", icon: "arrow-left" },
                      { text: "Right", apiName: "right", icon: "arrow-right" },
                    ]
                  : [
                      { text: "Top", apiName: "top", icon: "arrow-up" },
                      { text: "Bottom", apiName: "bottom", icon: "arrow-down" },
                    ]
              }
            /> */}
          </>
        )
      }

      {/* {edge.percentage !== null && (
        <>
          <Form.Label>Percentage</Form.Label>
          <Form.Control readOnly={true} value={edge.percentage.percentage} />
          <Button onClick={onSetPercentage}>Set percentage</Button>
        </>
      )} */}
    </>
  );
};
export default VariableFieldEdge;
